import React from "react";

export default function LocationIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_52_344)">
<path d="M7.5 9.70532C7.5 10.3684 7.76339 11.0042 8.23223 11.4731C8.70107 11.9419 9.33696 12.2053 10 12.2053C10.663 12.2053 11.2989 11.9419 11.7678 11.4731C12.2366 11.0042 12.5 10.3684 12.5 9.70532C12.5 9.04228 12.2366 8.4064 11.7678 7.93755C11.2989 7.46871 10.663 7.20532 10 7.20532C9.33696 7.20532 8.70107 7.46871 8.23223 7.93755C7.76339 8.4064 7.5 9.04228 7.5 9.70532Z" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.7141 14.4194L11.1783 17.9552C10.8657 18.2674 10.4421 18.4428 10.0003 18.4428C9.5586 18.4428 9.13493 18.2674 8.82242 17.9552L5.28576 14.4194C4.35344 13.487 3.71853 12.2992 3.46133 11.006C3.20412 9.71276 3.33616 8.37234 3.84076 7.15418C4.34535 5.93603 5.19984 4.89486 6.29616 4.16233C7.39248 3.4298 8.68139 3.03882 9.99992 3.03882C11.3184 3.03882 12.6074 3.4298 13.7037 4.16233C14.8 4.89486 15.6545 5.93603 16.1591 7.15418C16.6637 8.37234 16.7957 9.71276 16.5385 11.006C16.2813 12.2992 15.6464 13.487 14.7141 14.4194Z" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_52_344">
<rect width="20" height="20" fill="white" transform="translate(0 0.538574)"/>
</clipPath>
</defs>
</svg>

  );
}
